// extracted by LIB_CSS_EXTRACT_LOADER
import "./background-beams_module.css"
export default {"root":"root-d_c4_K","svg":"svg-A_WzRL"};